var usURL = 'https://bling2o.com';
var ukURL = 'https://bling2o.co.uk';
const mxURL = 'https://www.bling2o.mx';


$.getJSON('https://api.ipgeolocation.io/ipgeo?apiKey=6570b4c9c64243bfb726a0b8e1535d97', function(data) {
  //console.log(JSON.stringify(data, null, 2));
  country_code = data.country_code2
  console.log(country_code);

  if (window.location.origin.includes('myshopify.com')) {
    return;
  }
  	
    //=============== UK + Eire  =================
    if (( 
       country_code == 'GB' // United Kingdom (of Great Britain and Northern Ireland)
       || country_code == 'IE' // Ireland
       ) && window.location.origin != ukURL){
      	// redirect to UK site
     	window.location = ukURL;
      }

    // Mexico redirect
     if (country_code == 'MX' && window.location.origin != mxURL) {
       window.location = mxURL;
     }

    if (country_code == 'US' && window.location.origin != usURL) {
      window.location = usURL;
    }
  









  
//   //=============== united state =================
//   if (country_code == 'US'){
//     if(window.location.href.indexOf("us-bling2o.myshopify.com") > -1 || window.location.href.indexOf("bling2o.com") ) {
//        // not redirect
//     }
//     else{
//       // redirect to US site
//       window.location = usURL;
//     }
//   }
  
//   //=============== europe =================
  
//   if ( //country_code == 'AL' // Albania
//     //|| country_code == 'AD' // Andorra
//     //|| country_code == 'AM' // Armenia
//      country_code == 'AT' // Austria (also sometimes OE in German-speaking countries: for "Oesterreich"
//     //|| country_code == 'BY' // Belarus
//     || country_code == 'BE' // Belgium
//     //|| country_code == 'BA' // Bosnia and Herzegovina
//     || country_code == 'BG' // Bulgaria
//     //|| country_code == 'CH' // Switzerland (from Confoederatio Helvetica)
//     || country_code == 'CY' // Cyprus
//     || country_code == 'CZ' // Czech Republic
//     || country_code == 'DE' // Germany
//     || country_code == 'DK' // Denmark
//     || country_code == 'EE' // Estonia
//     || country_code == 'ES' // Spain
//     //|| country_code == 'FO' // Faeroe Islands
//     || country_code == 'FI' // Finland
//     || country_code == 'FR' // France
//     || country_code == 'GB' // United Kingdom (of Great Britain and Northern Ireland)
//     //|| country_code == 'GE' // Georgia
//     //|| country_code == 'GI' // Gibraltar
//     || country_code == 'GR' // Greece
//     || country_code == 'HU' // Hungary
//     || country_code == 'HR' // Croatia (local name: Hrvatska)
//     || country_code == 'IE' // Ireland
//     //|| country_code == 'IS' // Iceland
//     || country_code == 'IT' // Italy
//     || country_code == 'LT' // Lithuania
//     || country_code == 'LU' // Luxembourg
//     || country_code == 'LV' // Latvia
//     //|| country_code == 'MC' // Monaco
//     //|| country_code == 'MK' // Macedonia
//     || country_code == 'MT' // Malta
//     //|| country_code == 'NO' // Norway
//     || country_code == 'NL' // Netherlands
//     || country_code == 'PO' // Poland
//     || country_code == 'PT' // Portugal
//     || country_code == 'RO' // Romania
//     //|| country_code == 'RU' // Russian Federation
//     || country_code == 'SE' // Sweden
//     || country_code == 'SI' // Slovenia
//     || country_code == 'SK' // Slovakia (Slovakian Republic)
//     //|| country_code == 'SM' // San Marino
//     //|| country_code == 'TR' // Turkey
//     //|| country_code == 'UA' // Ukraine
//     //|| country_code == 'VA' // Vatican City State
//      ){
//       	// redirect to UK site
//       	window.location = ukURL;
//       }


  
});

